import * as $runtime from "../runtime.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dInt from "../Data.Int/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dSemiring from "../Data.Semiring/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dAnalytics$dTracking$dEvent from "../Restaumatic.Analytics.Tracking.Event/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
const itemValue = v => Data$dInt.toNumber(v.price) / 100.0 * Data$dInt.toNumber(v.quantity);
const convertItem = v => (
  {
    item_name: v.name,
    quantity: v.quantity,
    price: Data$dInt.toNumber(v.price) / 100.0,
    item_category: v.category,
    item_list_id: v.list.tag === "Just" ? Data$dMaybe.$Maybe("Just", Restaumatic$dAnalytics$dTracking$dEvent.showItemList.show(v.list._1)) : Data$dMaybe.Nothing
  }
);
const toPlatformEvent = currency => v => {
  if (v.tag === "AddToCart") {
    return {
      name: "add_to_cart",
      value: Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
        reflectSymbol: () => "value"
      })({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "items"})((() => {
        const $0 = Data$dFunctor.arrayMap(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
          reflectSymbol: () => "quantity"
        })({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "price"})({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}))({
          reflectSymbol: () => "item_name"
        })({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "item_list_id"})({
          encodeWithOptions: v$1 => v2 => {
            if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
            if (v2.tag === "Just") { return v2._1; }
            $runtime.fail();
          }
        }))({reflectSymbol: () => "item_category"})({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions));
        return {encodeWithOptions: v$1 => $0};
      })()))({reflectSymbol: () => "currency"})({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions)({
        currency,
        value: Data$dInt.toNumber(v._1.price) / 100.0 * Data$dInt.toNumber(v._1.quantity),
        items: [convertItem(v._1)]
      })
    };
  }
  if (v.tag === "LocateMe") { return {name: "locate_me", value: []}; }
  if (v.tag === "RemoveFromCart") {
    return {
      name: "remove_from_cart",
      value: Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
        reflectSymbol: () => "value"
      })({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "items"})((() => {
        const $0 = Data$dFunctor.arrayMap(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
          reflectSymbol: () => "quantity"
        })({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "price"})({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}))({
          reflectSymbol: () => "item_name"
        })({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "item_list_id"})({
          encodeWithOptions: v$1 => v2 => {
            if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
            if (v2.tag === "Just") { return v2._1; }
            $runtime.fail();
          }
        }))({reflectSymbol: () => "item_category"})({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions));
        return {encodeWithOptions: v$1 => $0};
      })()))({reflectSymbol: () => "currency"})({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions)({
        currency,
        value: Data$dInt.toNumber(v._1.price) / 100.0 * Data$dInt.toNumber(v._1.quantity),
        items: [convertItem(v._1)]
      })
    };
  }
  if (v.tag === "BeginCheckout") {
    return {
      name: "begin_checkout",
      value: Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
        reflectSymbol: () => "value"
      })({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "items"})((() => {
        const $0 = Data$dFunctor.arrayMap(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
          reflectSymbol: () => "quantity"
        })({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "price"})({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}))({
          reflectSymbol: () => "item_name"
        })({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "item_list_id"})({
          encodeWithOptions: v$1 => v2 => {
            if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
            if (v2.tag === "Just") { return v2._1; }
            $runtime.fail();
          }
        }))({reflectSymbol: () => "item_category"})({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions));
        return {encodeWithOptions: v$1 => $0};
      })()))({reflectSymbol: () => "currency"})({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions)({
        items: Data$dFunctor.arrayMap(convertItem)(v._1.items),
        value: Data$dFoldable.foldlArray(Data$dSemiring.numAdd)(0.0)(Data$dFunctor.arrayMap(itemValue)(v._1.items)),
        currency
      })
    };
  }
  if (v.tag === "Purchase") {
    return {
      name: "purchase",
      value: Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
        reflectSymbol: () => "value"
      })({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "transaction_id"})({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}))({
        reflectSymbol: () => "shipping"
      })({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "items"})((() => {
        const $0 = Data$dFunctor.arrayMap(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
          reflectSymbol: () => "quantity"
        })({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "price"})({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}))({
          reflectSymbol: () => "item_name"
        })({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "item_list_id"})({
          encodeWithOptions: v$1 => v2 => {
            if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
            if (v2.tag === "Just") { return v2._1; }
            $runtime.fail();
          }
        }))({reflectSymbol: () => "item_category"})({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions));
        return {encodeWithOptions: v$1 => $0};
      })()))({reflectSymbol: () => "currency"})({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "coupon"})({
        encodeWithOptions: v$1 => v2 => {
          if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
          if (v2.tag === "Just") { return v2._1; }
          $runtime.fail();
        }
      }))({reflectSymbol: () => "affiliation"})({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions)({
        items: Data$dFunctor.arrayMap(convertItem)(v._1.items),
        value: Data$dInt.toNumber(v._1.total) / 100.0,
        currency,
        affiliation: v._1.affiliation,
        shipping: Data$dInt.toNumber(v._1.shipping) / 100.0,
        transaction_id: v._1.transactionId,
        coupon: v._1.coupon
      })
    };
  }
  if (v.tag === "SetCheckoutOption") {
    return {
      name: "set_checkout_option",
      value: Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "selectedValue"})({
        encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce
      }))({reflectSymbol: () => "selectedOption"})({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions)({
        selectedOption: v._1.selectedOption,
        selectedValue: v._1.selectedValue
      })
    };
  }
  $runtime.fail();
};
export {convertItem, itemValue, toPlatformEvent};
